import { frontendURL } from 'dashboard/helper/URLHelper';
import ShiftManagementPage from './ShiftManagementPage.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/shift-management'),
    name: 'shift_management_index',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: ShiftManagementPage,
  },
];
